import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
  }

  toggle(event) {
    event.currentTarget
        .closest('li')
        .querySelector('ul[data-target="shared--accordion.box"]')
        .classList.toggle('is-hidden');
    event.currentTarget.closest('li').querySelector('.brands tr').classList.toggle('has-background-grey-lighter');
    event.currentTarget.querySelector('i').classList.toggle('fa-chevron-right');
    event.currentTarget.querySelector('i').classList.toggle('fa-chevron-down');
  }
}
